import { useLastPathSegment } from 'shared/hooks'
import { useAssignNumberStepsContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/context/useAssignNumberStepsContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useAssignNumberStepsContext()

  return getProgressInfoTitle(useLastPathSegment())
}
